import { RiLockLine } from "@remixicon/react";
import { cn } from "cn";
import type { ComponentProps } from "react";

interface LockedStateProps extends Omit<ComponentProps<"div">, "title"> {
  /** Что закрыто: «Библиотека», «Алерты». */
  title: string;
  /** Пояснение, чем открывается. */
  text: string;
}

/**
 * Экран-замок: на месте того, что недоступно. Замок, заголовок и пояснение;
 * ссылок и кнопок нет — только слова.
 */
function LockedState({ title, text, className, ...props }: LockedStateProps) {
  return (
    <div
      data-slot="locked-state"
      role="status"
      className={cn(
        "flex min-h-48 flex-col items-center justify-center gap-2 p-6 text-center",
        className,
      )}
      {...props}
    >
      <RiLockLine aria-hidden="true" className="size-6 text-muted-foreground" />
      <p className="text-sm font-semibold text-foreground">{title}</p>
      <p className="text-sm text-muted-foreground">{text}</p>
    </div>
  );
}

export { LockedState };
